/**
 * FilterBar
 * 
 * @Author: Focci
 * @Date: 2023-07-21 14:44:50
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-21 14:44:50
 */

'use client'

import useApp from '@hook/useApp'
import FilterBarReposive from './FilterBarReposive'
import FilterBarBody from './FilterBarBody'

export default function FilterBar(props) {
  const { isMobile } = useApp()

  if(isMobile) {
    return <FilterBarReposive {...props} />
  }

  return <FilterBarBody {...props} />
}
